const cards = (state = {}, data) => {
    if (data.action === 'SET_CARDS' && data.value) {
        return {
            ...data.value,
        }
    }
    return state
}

export default cards;